import shortid from "shortid";

export default function normalizeSourceItems(sourceItems: any[], transaction: any) {
  return sourceItems.map((s: any) => {
    let type = s?.optionableType;
    if (!type) type = transaction.type;
    let option = s?.optionType || s?.Account_Type;
    if (option) {
      const { title, name, nickName, personName, accountingCode, id } = option;
      option.title = title || name || nickName || personName;
      option.accountingCode = accountingCode || id;
    }
    return {
      ind: shortid.generate(),
      edit: false,
      data: {
        person: type === "person" ? s.optionableId : undefined,
        cost: type === "cost" ? option?.id : undefined,
        income: type === "income" ? option?.id : undefined,
        price: Math.abs(s.amount),
        reference: s.reference,
        factor: s.factorId,
        typeOption: option,
      },
      done: true,
      type: type,
      typeOption: option,
    };
  });
}
